
const dateFormatDDMMYYYY = (date_val) => {
    const dateVal = new Date(date_val).toLocaleDateString('en-IN', {day: 'numeric',month: 'long',year: 'numeric'}) 
    return dateVal;
};

export default { dateFormatDDMMYYYY }